<section id="steps" class="wl-section steps">
  <div class="wl-inner inner">
    <app-section-heading
      eyebrow="Jak to działa"
      title="Cztery kroki do momentu,<br>który zapamiętają wszyscy" />
    <div class="wl-steps">
      @for (step of steps; track step.n; let last = $last) {
        <div>
          <div class="step-head">
            <div class="step-num" [class.accent]="last">{{ step.n }}</div>
            @if (!last) {
              <div class="step-line"></div>
            }
          </div>
          <h3 class="step-title">{{ step.title }}</h3>
          <p class="step-text">{{ step.text }}</p>
        </div>
      }
    </div>
  </div>
</section>
